import tinymce from 'tinymce/tinymce'

tinymce.PluginManager.add('imageSelector', function (editor) {
  editor.ui.registry.addButton('imageSelector', {
    icon: 'image',
    tooltip: '插入图片',
    onAction: function () {
        console.log(123)
      // onAction意思是，点击上传图片按钮触发的事件，所以这里可以自由发挥。
    }
  })
})